import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { HttpBackend, HttpClient,HttpHeaders } from '@angular/common/http';
import { retryWhen } from 'rxjs/operators';

@Component({
  selector: 'app-fee-details',
  templateUrl: './fee-details.component.html'
})
export class FeeDetailsComponent implements OnInit {

  form: FormGroup;
  JSON;
  isgPay_url:string;
  todayDate:Date;

  @ViewChild('txnForm') txnForm: any;
  tranxnForm : FormGroup;
  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  commonUtility:CommonUtility;
  loading = false;
  name:any='';
  fathersName:any='';
  courseLoader = false;
  subscription:any;
  amount:any;
  semester:any;
  semesterList:any;
  source:any;
  type:any='';
  row:any='';
  disableSelect;
  totalAmount:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string;
  BankIdField:string;
  TerminalIdField:string;
  VersionField:string;
  myDIV: Boolean = false ;
  totalDisabled:boolean=true;
  fetchFeesType:any;
  fetchFee:any;
  subscriptionList:string[] = ['Half Yearly','Yearly','Three Years'];
  captcha:any;
  initialCap: any;
  submitted = false;

  


  constructor(
    private http:HttpClient,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService
  ) {
    this.JSON=JSON;
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;

   }
  
  ngOnInit(): void {
   
    this.todayDate = new Date();
  this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:['']

         });
      this.form = this.formBuilder.group({
        customerName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        address: ["",[Validators.required]],
        mobileNo: ["",[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]],
        emailId: ["",[Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]],
        bookname: [""],
        subscription: ["",[Validators.required]],
        totalAmount: ["",[Validators.required,Validators.pattern("^[0-9]*$")]],
        remarks: [""],
        captcha : ["", [Validators.required]]  
     
      });
      this.Cap();
  }

  onSubscriptionChange(event)
  {
    console.log("Event" ,event.value);
    let req={
      "subscription":event.value
  }
  this.categoryService.fetchBySubscriptionType(req).subscribe(res=>{
    console.log(res);
    if(res && res['body'] && res['body']['data']){
      console.log(res['body']['data']['totalAmount']);
      this.form.controls['totalAmount'].setValue(res['body'] && res['body']['data']['totalAmount']);
    }
  },err=>{
    console.log(err);
  })

  }

  ValidCaptcha(){
    let str1=this.initialCap
    let str2=this.form.get('captcha').value;
    if(str2.toUpperCase()!="") {
    if(str1 == str2.toUpperCase()){
      this.form.controls['captcha'].setErrors(null);
      return true;
    }else{
      this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
      return false;
    }
    }
    else {
      this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
    }
  }

  Cap() {
    let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
     var apl1 = alpha[Math.floor(Math.random() * 36)];
     var apl2 = alpha[Math.floor(Math.random() * 36)];
     var apl3 = alpha[Math.floor(Math.random() * 36)];
     var apl4 = alpha[Math.floor(Math.random() * 36)];
     var apl5 = alpha[Math.floor(Math.random() * 36)];
     var apl6 = alpha[Math.floor(Math.random() * 36)];
     this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;

    }
  

  get f()
 { return this.form.controls; }

  Submit():void{

    var routeUrl;
    this.submitted = true;

    if(this.form.controls.totalAmount.value == 0)
    {
      this.commonUtility.alertMsg('Total Amount Should Not be Zero , Please Enter the Total Amount','',false);
    }
    else{
      if (this.form.invalid || (!this.ValidCaptcha())) {
      return;
    }


    let req = {
      'customerName': this.form.controls.customerName.value,
      'address': this.form.controls.address.value,
      'mobileNo': this.form.controls.mobileNo.value,
      'emailId': this.form.controls.emailId.value,
      'bookname': this.form.controls.bookname.value,
      'subscription': this.form.controls.subscription.value,
      'totalAmount': this.form.controls.totalAmount.value,
      'remarks': this.form.controls.remarks.value,
      'source': 'HINDI',
      "captcha":this.form.controls.captcha.value
    }

    const encodedCaptcha = btoa(this.form.controls.captcha.value);
    //console.log("Encoded CAPTCHA--",encodedCaptcha);     
    //console.log("On Submit Req-------",req); 
    routeUrl = 'payment/pay-details';


    console.log("req : ");
    this.categoryService.submitHindiDetails(req,encodedCaptcha).subscribe(res =>  {

      if(res.body.statusCode === "00000")
      {
       this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
       this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
       this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
       this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
       this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
       this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

       this.EncDataField  	= res.body.data.fields.EncData;
       this.MerchantIdField = res.body.data.fields.MerchantId;
       this.BankIdField = res.body.data.fields.BankId;
       this.TerminalIdField = res.body.data.fields.TerminalId ;
       this.VersionField = res.body.data.fields.Version ;
       this.txnForm.nativeElement.submit();

      }
      else{
       this.commonUtility.alertMsg(res.body.statusDesc,'',false);
      }
      this.Cap();
       this.loading = false;
            },(error)=>{
              this.Cap();
              this.commonUtility.alertMsg(JSON.stringify(error.statusText) ,'',false);}
      )
     }
    }




  onSubmit(): void
{

}
hideError(controlName:any)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }

    }



}
